import React from 'react';
import CustomTable from './CustomTable';
import "./MyRequest.styles.css";

const MyRequest = () => {

  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>My Request</h2>
          {/* <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus
                  </p> */}
        </div>
            
            <div className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                    
                                    <div className="box-border" style={{margin:"auto",width:"100%",padding:"0"}}>
                                      <CustomTable/>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
      </div>
    </div>
  );
};

export default MyRequest;
